import { createWidget } from '@alfa-bank/site-util-create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { Badge as Component } from '../component';
import type { IBadgeDeps, TBadge } from '../models';

import styles from './styles.css';

export const BadgeDesktop = createWidget<IBadgeDeps, TBadge>({
    Text,
    styles,
    view: 'secondary-medium',
})(Component);
